import React from "react";
import { Link } from "react-router-dom";

const ActionLink = ({
  label,
  to,
  href,
  external = false,
  variant = "solid",
  className = "",
}) => {
  const classes = `button button--${variant} ${className}`.trim();

  if (to) {
    return (
      <Link className={classes} to={to}>
        {label}
      </Link>
    );
  }

  return (
    <a
      className={classes}
      href={href}
      rel={external ? "noreferrer" : undefined}
      target={external ? "_blank" : undefined}
    >
      {label}
    </a>
  );
};

export default ActionLink;
